var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6664 16C15.9802 16 18.6664 13.3137 18.6664 10C18.6664 6.68629 15.9802 4 12.6664 4C9.35274 4 6.66645 6.68629 6.66645 10C6.66645 13.3137 9.35274 16 12.6664 16Z",
    fill: "#5834A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6664 20C8.89228 20 5.53783 22.0594 3.41209 25.2511C2.9464 25.9503 2.71355 26.2999 2.74036 26.7466C2.76123 27.0943 2.98918 27.52 3.26703 27.7301C3.62389 28 4.11468 28 5.09626 28H20.2366C21.2182 28 21.709 28 22.0659 27.7301C22.3437 27.52 22.5717 27.0943 22.5925 26.7466C22.6193 26.2999 22.3865 25.9503 21.9208 25.2511C19.7951 22.0594 16.4406 20 12.6664 20Z",
    fill: "#5834A8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 21.1158C25.941 22.091 27.6053 23.6559 28.8201 25.6128C29.0607 26.0004 29.181 26.1941 29.2225 26.4624C29.3071 27.0077 28.9342 27.678 28.4264 27.8938C28.1765 28 27.8954 28 27.3331 28M21.3331 15.3763C23.3087 14.3945 24.6664 12.3558 24.6664 10C24.6664 7.64419 23.3087 5.60548 21.3331 4.62368M18.6664 10C18.6664 13.3137 15.9802 16 12.6664 16C9.35274 16 6.66645 13.3137 6.66645 10C6.66645 6.68629 9.35274 4 12.6664 4C15.9802 4 18.6664 6.68629 18.6664 10ZM3.41209 25.2511C5.53783 22.0594 8.89228 20 12.6664 20C16.4406 20 19.7951 22.0594 21.9208 25.2511C22.3865 25.9503 22.6193 26.2999 22.5925 26.7466C22.5717 27.0943 22.3437 27.52 22.0659 27.7301C21.709 28 21.2182 28 20.2366 28H5.09626C4.11468 28 3.62389 28 3.26703 27.7301C2.98918 27.52 2.76123 27.0943 2.74036 26.7466C2.71355 26.2999 2.9464 25.9503 3.41209 25.2511Z",
    stroke: "#5834A8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers03);
export default __webpack_public_path__ + "static/media/users-03.d4f01b09ec9548595d8e84ad440e63eb.svg";
export { ForwardRef as ReactComponent };